import { connect } from 'react-redux';
import SetPasswordPage from './Main';
import { bindActionCreators } from 'redux';
import { phonePrefixes } from 'Store/Selectors/AuthSelector';
import * as Types from 'Shared/models/AuthModel';
import { adminLogin } from 'Store/Actions/Auth';
type ConnectedP = {
  phonePrefixes: Array<Types.PhonePrefix>;
};

type DispatchedP = {
  actions: {
    adminLogin: ({ email, password }) => (dispatch: any) => Promise<boolean>;
  };
};
const mapStateToProps = (state) => ({
  phonePrefixes: phonePrefixes(state),
});

const mapDispatchToProps = (dispatch): DispatchedP => ({
  actions: bindActionCreators(
    {
      adminLogin: adminLogin,
    },
    dispatch,
  ),
});

export type MainType = ConnectedP & DispatchedP;

export default connect(mapStateToProps, mapDispatchToProps)(SetPasswordPage);
